module.exports = __webpack_public_path__ + "img/lordsmobile.efa3c87.png";